import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { shape, func, bool, arrayOf } from "prop-types";
import classNames from "classnames";
import Head from "pages/_components/Head";
import I18n from "pages/_components/I18n";
import Col from "react-bootstrap/lib/Col";
import FieldLabel from "pages/_components/fields/FieldLabel";
import Row from "react-bootstrap/lib/Row";
import Container from "pages/_components/Container";
import FormattedDate from "pages/_components/FormattedDate";
import FormattedAmount from "pages/_components/FormattedAmount";
import Image from "pages/_components/Image";
import MainContainer from "pages/_components/MainContainer";
import Button from "pages/_components/Button";
import Notification from "pages/_components/Notification";
import { selectors as transactionsSelectors, actions as transactionsActions } from "reducers/transactions";
import { actions as layoutActions } from "reducers/layout";
import * as i18nUtils from "util/i18n";
import { isMvp3PendingTransactionsEnabled, isMvp5PendingTransactionsEnabled } from "util/transaction";
import { buildGroupedSummary } from "util/multipleSignaturesProcessingSummary";
import { push } from "react-router-redux";
import { resizableRoute } from "pages/_components/Resizable";
import { isUxDashboardImprovementsEnabled } from "util/v3ShellLayoutSync";

class ProcessingMultipleDelete extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        multipleSignaturesData: shape({}).isRequired,
        isDesktop: bool.isRequired,
        selectedTransactionRowsFromStore: arrayOf(shape({})),
        embeddedInV3Shell: bool,
    };

    static defaultProps = {
        selectedTransactionRowsFromStore: [],
        embeddedInV3Shell: false,
    };

    componentDidMount() {
        this.applyEmbeddedV3ShellLayout();
    }

    componentDidUpdate(prevProps) {
        const { embeddedInV3Shell, isDesktop } = this.props;
        if (prevProps.embeddedInV3Shell !== embeddedInV3Shell || prevProps.isDesktop !== isDesktop) {
            if (prevProps.embeddedInV3Shell && !embeddedInV3Shell) {
                this.clearEmbeddedV3ShellLayout();
            }
            this.applyEmbeddedV3ShellLayout();
        }
    }

    clearEmbeddedV3ShellLayout = () => {
        const { dispatch } = this.props;
        dispatch(layoutActions.setScopes([]));
        dispatch(layoutActions.setTitleKey(""));
        dispatch(layoutActions.setGoBackPath(null));
        dispatch(layoutActions.setRightContentMobile(null));
    };

    applyEmbeddedV3ShellLayout = () => {
        const { embeddedInV3Shell, isDesktop, dispatch } = this.props;
        if (!embeddedInV3Shell || !isUxDashboardImprovementsEnabled()) {
            return;
        }
        dispatch(layoutActions.setScopes(["multipleDeleteProcessing"]));
        if (!isDesktop) {
            dispatch(layoutActions.setTitleKey("pendingDispatch.list.title"));
            dispatch(layoutActions.setGoBackPath("/pendingTransaction/list"));
            dispatch(layoutActions.setRightContentMobile(null));
        } else {
            dispatch(layoutActions.setTitleKey(""));
            dispatch(layoutActions.setGoBackPath(null));
            dispatch(layoutActions.setRightContentMobile(null));
        }
    };

    componentWillUnmount = () => {
        const { dispatch, embeddedInV3Shell } = this.props;
        if (embeddedInV3Shell) {
            this.clearEmbeddedV3ShellLayout();
        }
        dispatch(
            transactionsActions.setMultipleSignaturesData({
                activitySelected: "",
                selectedRows: [],
                selectedTransactionRows: [],
            }),
        );
    };

    centerContentMobile = () => (
        <div className="title-account-header-multiline-background-blue">
            <h1>{i18nUtils.get("pendingDispatch.list.title")}</h1>
        </div>
    );

    handleBack = () => {
        const { dispatch } = this.props;
        dispatch(push("/pendingTransaction/list"));
    };

    render() {
        const {
            multipleSignaturesData,
            dispatch,
            isDesktop,
            selectedTransactionRowsFromStore,
            embeddedInV3Shell,
        } = this.props;
        const showLegacyHead = !embeddedInV3Shell || isDesktop;
        const postFlowHomePath = embeddedInV3Shell ? "/v3/dashboard" : "/desktop";
        const isMvp5 = isMvp5PendingTransactionsEnabled();
        const fromMultipleSignatures = multipleSignaturesData?.selectedTransactionRows;
        const rows =
            fromMultipleSignatures?.length > 0 ? fromMultipleSignatures : selectedTransactionRowsFromStore ?? [];
        const groupedSummary = isMvp5 ? buildGroupedSummary(rows) : [];

        return (
            <>
                {!embeddedInV3Shell && <Notification scopeToShow="multipleDeleteProcessing" />}
                {showLegacyHead && (
                    <div className="admin-detail-head px-0">
                        <Head
                            onBack={!isDesktop && this.handleBack}
                            uniqueDownload
                            handleClick={this.exportPdf}
                            handleClickMessage="global.download"
                            isFetchingExport={false}
                            hasInlineButtons
                            headerClassName={!isDesktop ? "blue-main-header-mobile" : ""}
                            centerElement={isDesktop ? undefined : this.centerContentMobile}
                            emptyRightOption
                        />
                    </div>
                )}
                <MainContainer>
                    <div className="above-the-fold">
                        <Container className="flex-grow align-items-center">
                            <Col className="col col-xl-6 ">
                                <Container className="flex-grow align-items-center">
                                    <Col className="col col-xl-10 cmf-container-white">
                                        <div className="admin-content-center" style={{ margin: "2rem 0" }}>
                                            <Image
                                                src="images/processing.svg"
                                                styles={{ width: "102.5px", height: "102.5px" }}
                                            />
                                        </div>
                                        <div className="admin-content-center" style={{ "font-size": "19px" }}>
                                            <I18n id="multiple.signatures.processing" />
                                        </div>
                                        <div className="pending-transactions__processing-receipt-body">
                                            <Row className="d-flex align-items-center justify-content-between mx-0 pending-transactions__processing-receipt-row">
                                                <FieldLabel
                                                    idField="multipleDeleteProcessingDate"
                                                    labelKey="account.new.account.date"
                                                    notMarginY
                                                />
                                                <div className="pending-transactions__processing-receipt-value">
                                                    <FormattedDate
                                                        date={new Date()}
                                                        dateFormat="dd/MM/yyyy"
                                                        showTime
                                                        withSpan
                                                    />
                                                </div>
                                            </Row>
                                            {isMvp5 ? (
                                                <Row className="d-flex flex-column align-items-stretch justify-content-between mx-0 pending-transactions__processing-receipt-row">
                                                    <FieldLabel
                                                        idField="multipleDeleteProcessingCount"
                                                        labelKey="multiple.signatures.count"
                                                        notMarginY
                                                    />
                                                    {rows.length === 0 ? (
                                                        <div className="m-0 text-14">0</div>
                                                    ) : (
                                                        groupedSummary.map((group) => (
                                                            <div
                                                                key={`${group.idActivity}-${group.currency}`}
                                                                className="m-0 text-14 text-left mb-1">
                                                                {group.count} {group.label}
                                                                {group.currency !== "none" && (
                                                                    <>
                                                                        {i18nUtils.get(
                                                                            "multiple.signatures.summary.amount.de",
                                                                        )}
                                                                        <FormattedAmount
                                                                            cleanClassName
                                                                            notBold
                                                                            fontClassName="text-14"
                                                                            className="mb-0 d-inline-block"
                                                                            currency={group.currency}
                                                                            quantity={group.amount}
                                                                        />
                                                                    </>
                                                                )}
                                                            </div>
                                                        ))
                                                    )}
                                                </Row>
                                            ) : (
                                                <Row className="d-flex align-items-center justify-content-between mx-0 pending-transactions__processing-receipt-row">
                                                    <FieldLabel
                                                        idField="multipleDeleteProcessingCount"
                                                        labelKey="multiple.signatures.count"
                                                        notMarginY
                                                    />
                                                    <div className="pending-transactions__processing-receipt-value">
                                                        {multipleSignaturesData?.selectedRows?.length}
                                                    </div>
                                                </Row>
                                            )}
                                            <Row className="mx-0">
                                                <p className="mb-0">
                                                    {i18nUtils.get("multiple.signatures.process.explanation")}
                                                </p>
                                            </Row>
                                        </div>
                                    </Col>
                                </Container>
                            </Col>
                        </Container>
                        <Container className="flex-grow align-items-center">
                            <Col className="col col-xl-6">
                                <Container className="flex-grow align-items-center">
                                    <Col
                                        className={classNames("col col-xl-12 col-no-pad-mobile mt-2", {
                                            "d-flex align-items-center gap-2": isDesktop,
                                        })}>
                                        <Button
                                            type="button"
                                            bsStyle="outline"
                                            onClick={() => {
                                                if (!isMvp3PendingTransactionsEnabled()) {
                                                    dispatch(transactionsActions.initPendings());
                                                }
                                                dispatch(push("/pendingTransaction/list"));
                                            }}
                                            label="goto.pendings.transaction.autorizaciones"
                                        />
                                        <Button
                                            type="button"
                                            bsStyle="primary"
                                            onClick={() => dispatch(push(postFlowHomePath))}
                                            label="new.check.right.buttom"
                                        />
                                    </Col>
                                </Container>
                            </Col>
                        </Container>
                    </div>
                </MainContainer>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    multipleSignaturesData: transactionsSelectors.getMultipleSignaturesData(state),
    selectedTransactionRowsFromStore: transactionsSelectors.getSelectedTransactionRows(state),
});

export default compose(connect(mapStateToProps), resizableRoute)(ProcessingMultipleDelete);
